import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GeneratedClientManagerService } from '../generated-client-manager.service';
import { FrontendSettingsClient, FrontendSettingsDto } from '../simulation.generated.client';

@Injectable()
export class FrontendSettingsService extends GeneratedClientManagerService {
  private _client: FrontendSettingsClient;

  constructor() {
    super();
    this._client = new FrontendSettingsClient(this.httpClient, this.baseUrl);
  }

  getFrontendSettings(): Observable<FrontendSettingsDto> {
    return this._client.getFrontendSettings();
  }
}
